import {getLogEvents, setLogEvents} from 'utils/persistence'

import {identifyWithMetaPixelCookies} from '@vio/core/src/_web/utils/cookies/pollForFbpCookie'
import {runInIdleTime} from '@vio/core/src/_web/utils/performance/idleUntilUrgent'
import AnalyticsUtils from '@vio/core/src/analytics/utils'
import {Brand} from '@vio/core/src/brand/types'

const getLogEventsParam = () => {
  if (typeof window !== 'undefined')
    return new URLSearchParams(window.location.search).get('logEvents')
}

const initializeAnalytics = (anonymousId: string, brand: Brand) => {
  const ANALYTICS_ENDPOINT = process.env.NEXT_PUBLIC_ANALYTICS_ENDPOINT
  const API_KEY = process.env.NEXT_PUBLIC_ANALYTICS_API_KEY
  const GTM_CONTAINER_ID = brand.analytics
    ? brand.analytics.gtm.containerId
    : process.env.NEXT_PUBLIC_GTM_ID

  const integrations = {
    'Segment.io': {
      apiKey: API_KEY,
      apiHost: ANALYTICS_ENDPOINT
    },
    'Google Tag Manager': {
      containerId: GTM_CONTAINER_ID,
      // This prevents double page view tracking
      trackCategorizedPages: false
    }
  }

  // Switch for easier debugging
  const logEventsParam = getLogEventsParam()
  if (logEventsParam) setLogEvents(logEventsParam)
  const logEvents = getLogEvents() === '1'

  AnalyticsUtils.setLogEventsStatus(logEvents)
  AnalyticsUtils.initialize(integrations, anonymousId)

  /** Meta pixel cookies. Helpful for retargeting.
   * https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
   */
  runInIdleTime(() => {
    identifyWithMetaPixelCookies(({fbp, fbc}) => {
      AnalyticsUtils.identify(undefined, {fbp, fbc})
    })
  })
}

export default initializeAnalytics
